import { gql, useQuery } from "urql";
import ProtectedRoute from "../../components/ProtectedRoute";
import Loading from "../../components/Loading";
import { toIDRFormat } from "../../utils/toIDRFormat";
import { useState, useContext } from "react";
import Dialog from "../../components/Dialog";
import AppContext from "../../context/appContext";
import { useRouter } from "next/router";
import toast from "react-hot-toast";

const query = gql`
  query MyQuery {
    class_registrations(
      where: {
        reregistration_end_date: { _gt: "now()" }
        class_header: {
          name: { _eq: "Awesome Competition 2024 - Winter Edition" }
        }
      }
    ) {
      id
      class_fee
      reregistration_end_date
      reregistration_start_date
      class_header {
        name
        program {
          name
        }
      }
      name
    }
  }
`;

const formatData = (data) => {
  const groupedData = data?.reduce((acc, registration) => {
    const programName = registration.class_header.program.name;
    const classHeaderName = registration.class_header.name;

    if (!acc[programName]) {
      acc[programName] = {};
    }

    if (!acc[programName][classHeaderName]) {
      acc[programName][classHeaderName] = [];
    }

    acc[programName][classHeaderName].push({
      id: registration.id,
      name: registration.name ?? classHeaderName,
      class_fee: registration.class_fee,
      is_test: false,
    });

    return acc;
  }, {});

  return groupedData;
};
function Index() {
  const { auth } = useContext(AppContext);
  const { push } = useRouter();
  const [{ data, fetching }] = useQuery({ query: query });
  const [isLoading, setIsLoading] = useState(false);

  const [transaction, setTransaction] = useState([]);
  const [newStudent, setNewStudent] = useState(false);
  const [open, setOpen] = useState(false);

  const classRegistrations = formatData(data?.class_registrations);

  const handleCheckboxChange = (classData, checked) => {
    if (checked) {
      setTransaction((prev) => [...prev, classData]);
    } else {
      setTransaction((prev) => prev.filter((item) => item.id !== classData.id));
    }
  };

  // 5000 admin fee
  const totalPrice =
    transaction.reduce(
      (total, classData) => total + classData.class_fee,
      newStudent ? 200000 : 0
    ) + 5000;

  const handleSubmit = async (auth, newStudent, transaction) => {
    try {
      setIsLoading(true);

      const transactionsID = transaction.map((item) => {
        return item.id;
      });

      const req = await fetch("/api/v1/transactions/classes", {
        method: "POST",
        headers: { Authorization: "Bearer " + auth },
        body: JSON.stringify({
          is_new_student: newStudent,
          class_registration_id: transactionsID,
        }),
      });

      const { data, error, status } = await req.json();

      if (error) {
        throw new Error(error);
      }
      window?.snap?.pay(data, {
        onSuccess: function () {
          push({
            pathname: "/payment-success",
          });
        },
        onPending: function () {
          console.log("pending/gagal bayar");
        },
        onError: function (result) {
          /* You may add your own implementation here */
          toast.error("payment failed!");
          console.log(result);
        },
        onClose: function () {
          console.log("pending/gagal bayar");
        },
      });
    } catch (err) {
      toast.error(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <main className="mx-auto flex h-full w-full max-w-[1280px] flex-col gap-5 px-4 pb-10 pt-24 md:pt-36">
        <h2 className="text-center">Pembayaran Final</h2>

        {classRegistrations
          ? Object.keys(classRegistrations).map((programName) => (
              <div key={programName} className="mb-6">
                <h2 className="mb-4 text-2xl font-bold capitalize">
                  {programName}
                </h2>
                {Object.keys(classRegistrations[programName]).map(
                  (classHeaderName) => (
                    <div key={classHeaderName} className="mb-4">
                      <h3 className="mb-2 text-xl font-semibold">
                        {classHeaderName}
                      </h3>
                      <ul className="list-inside list-disc">
                        {classRegistrations[programName][classHeaderName].map(
                          (classData, index) => (
                            <li key={index} className="mb-1 flex items-center">
                              <input
                                type="checkbox"
                                className="mr-2"
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    classData,
                                    e.target.checked
                                  )
                                }
                              />
                              <span>
                                {classData.name}:{" "}
                                {toIDRFormat(classData.class_fee)}{" "}
                              </span>
                            </li>
                          )
                        )}
                      </ul>
                    </div>
                  )
                )}
              </div>
            ))
          : null}

        <button
          onClick={() => setOpen(true)}
          disabled={transaction.length === 0}
          className="mt-8 w-full rounded-md bg-[#177ECD] py-2.5 ring-2 ring-inset ring-[#F0F0F0] hover:bg-opacity-80 disabled:cursor-not-allowed"
        >
          <p className="text-center text-base font-semibold text-[#FFFFFF]">
            Submit
          </p>
        </button>
      </main>

      {open && (
        <Dialog
          header={"Checkout"}
          needClose={true}
          setState={() => setOpen(false)}
        >
          <div className="mt-4">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
                    Class Name
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
                    Price
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 bg-white">
                <tr>
                  <td className="whitespace-nowrap px-6 py-4 text-sm font-medium text-gray-900">
                    Admin Fee
                  </td>
                  <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
                    {toIDRFormat(5000)}
                  </td>
                </tr>
                {transaction.map((classData) => (
                  <tr key={classData.id}>
                    <td className="whitespace-nowrap px-6 py-4 text-sm font-medium text-gray-900">
                      {classData.name}
                    </td>
                    <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
                      {toIDRFormat(classData.class_fee)}
                    </td>
                  </tr>
                ))}
                {newStudent && (
                  <tr>
                    <td className="whitespace-nowrap px-6 py-4 text-sm font-medium text-gray-900">
                      New Student Fee
                    </td>
                    <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
                      {toIDRFormat(200000)}
                    </td>
                  </tr>
                )}
                <tr>
                  <td className="whitespace-nowrap px-6 py-4 text-sm font-medium text-gray-900">
                    Total
                  </td>
                  <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
                    {toIDRFormat(totalPrice)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="mt-6 flex justify-end gap-4">
            <button
              className="rounded bg-gray-500 px-4 py-2 text-white"
              onClick={() => setOpen(false)}
            >
              Cancel
            </button>
            <button
              className="rounded bg-green-500 px-4 py-2 text-white"
              onClick={() => {
                handleSubmit(auth, newStudent, transaction);
              }}
            >
              Proceed
            </button>
          </div>
        </Dialog>
      )}

      {fetching ? (
        <div className="fixed left-0 top-0 z-[150] flex h-screen w-screen items-center justify-center bg-black bg-opacity-10">
          <Loading fillcolor={"#EA374C"} />
        </div>
      ) : null}
    </>
  );
}

export default ProtectedRoute(Index);
// export default Index;
